<template>
  <base-dialog-form ref="gestSchedeDialog" height="90vh" :title="$t('manage_evaluation_tables')" color="secondary"
    icon="mdi-clipboard-list-outline">
    <template v-slot:actions>
      <v-col cols="12" class="text-center">
        <v-btn class="mx-5" @click="saveScheda(false)" color="success">{{
          method === "ADD" ? $t("create") : $t("save")
        }}</v-btn>
        <v-btn class="mx-5" v-if="method === 'EDIT'" @click="saveScheda(true)" color="success">{{
          $t("copy_evaluation_tables") }}</v-btn>
        <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deleteScheda" color="error">{{ $t("delete") }}</v-btn>
      </v-col>
    </template>
    <template v-slot:header>
      <v-col cols="12">
        <v-btn style="float: left" small class="mx-2" @click="createScheda" color="primary">{{
          $t("create_evaluation_tables") }}</v-btn>
        <v-autocomplete v-model="selectedScheda" :items="listSchede" v-if="listSchede.length > 0" item-text="nomeScheda"
          item-value="idScheda" dense :label="$t('select_evaluation_tables')"></v-autocomplete>
      </v-col>
    </template>
    <v-container>
      <v-row v-if="schedaData">
        <v-col cols="12">
          <v-btn style="float: left" small class="mx-2" @click="addSchedaDettaglio" color="primary">{{ $t("new_details")
          }}</v-btn>
          <v-text-field dense class="mx-2" v-model="schedaData.nomeScheda" :label="$t('name')" :rules="required"
            hide-details="auto"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel :v-if="schedaData.dettaglio" v-for="dettaglio in schedaData.dettaglio"
              v-bind:key="dettaglio.idDettaglio" class="mr-3">
              <v-expansion-panel-header>
                <v-row no-gutters style="width: 100%">
                  <v-col cols="11">
                    {{ dettaglio.nameTranslations[defaultLang] }}
                    <v-btn icon large color="red" min-width="0" style="float: right; height: 32px"
                      @click.stop="deleteSchedaDettaglio(dettaglio)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-text-field style="float: right" dense class="mx-2" v-model.number="dettaglio.maxPoint"
                      type="number" :label="$t('points')" :rules="required" hide-details="auto"></v-text-field>
                    <v-text-field style="float: right" dense class="mx-2" v-model.number="dettaglio.ordine" type="number"
                      :label="$t('order')" :rules="required" hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    {{ dettaglio.maxPoint }} / {{ totPoint }} &nbsp;&nbsp;&nbsp;
                    <span style="float: right">{{
                      parseInt((dettaglio.maxPoint * 100) / totPoint)
                    }}%</span>

                    <v-progress-linear color="primary" :value="(dettaglio.maxPoint * 100) / totPoint"></v-progress-linear>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card class="my-2" v-for="lang in supportedLanguage" v-bind:key="lang.language">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <img style="
                                float: left;
                                margin-right: 12px;
                                margin-top: 10px;
                              " :src="lang.flag" />
                        <v-text-field v-model="dettaglio.nameTranslations[lang.language]" :label="$t('title')"
                          :rules="required" hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field v-model="dettaglio.descrTranslations[lang.language]" :label="$t('description')"
                          :rules="required" hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </base-dialog-form>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "edit-schede",
  components: {},
  data() {
    return {
      RBAC_eventi_EDIT_GARE: false,
      gestSchedeDialog: false,
      required: [(value) => !!value || this.$t("required_field")],
      panel: [],
      method: null,
      schedaData: null,
      selectedScheda: null,
      listSchede: [],
    };
  },
  computed: {
    totPoint: function () {
      let _ = this;
      let totale = 0;
      if (
        _.schedaData &&
        _.schedaData.dettaglio &&
        _.schedaData.dettaglio.length > 0
      ) {
        for (let dett of _.schedaData.dettaglio) {
          totale = totale + dett.maxPoint;
        }
      }
      return totale;
    },
    supportedLanguage: function () {
      return window.systemData.supportedLanguage
        .filter((lang) => {
          return lang.ifActive === 1;
        })
        .sort((a, b) => {
          let order = 0;
          if (
            a.language === window.systemData.defaultLanguage &&
            b.language !== window.systemData.defaultLanguage
          )
            order = -1;
          else if (
            b.language === window.systemData.defaultLanguage &&
            a.language !== window.systemData.defaultLanguage
          )
            order = 1;
          else if (a.language > b.language) order = 1;
          else if (a.language < b.language) order = -1;
          else order = 0;
          return order;
        });
    },
    defaultLang: function () {
      return window.systemData.defaultLanguage;
    },
  },
  watch: {
    selectedScheda: function (newVal, oldVal) {
      // watch it
      this.getScheda();
    },
  },
  methods: {
    open() {
      this.selectedScheda = null;
      this.loadData();
      this.$refs.gestSchedeDialog.open();
    },
    loadData() {
      let _ = this;
      _.RBAC_eventi_EDIT_GARE = this.checkUserRole("eventi", "EDIT_GARE");
      _.chiamataAxios("GET", "/auth/eventi/listSchedeValutazione").then(
        (response) => {
          _.listSchede = response.data.map(scheda => {
            scheda.nomeScheda = scheda.idScheda + ": " + scheda.nomeScheda
            return scheda;
          });
          if (!_.selectedScheda && response.data.length > 0)
            _.selectedScheda = response.data[0].idScheda;
        }
      );
    },
    deleteSchedaDettaglio(item) {
      let _ = this;
      _.schedaData.dettaglio = _.schedaData.dettaglio.filter((element) => {
        return element.idSchedaDettaglio !== item.idSchedaDettaglio;
      });
    },
    addSchedaDettaglio() {
      let _ = this;
      let maxOrdine = 0;
      _.schedaData.dettaglio.forEach((element) => {
        if (element.ordine > maxOrdine) maxOrdine = element.ordine;
      });

      let newDett = {
        idSchedaDettaglio: _.schedaData.dettaglio.length + 1,
        ordine: maxOrdine + 1,
        maxPoint: 0,
        name: "",
        descr: "",
        nameTranslations: {},
        descrTranslations: {},
      };
      _.supportedLanguage.forEach((lang) => {
        newDett.nameTranslations[lang] = "";
        newDett.descrTranslations[lang] = "";
      });
      _.schedaData.dettaglio.push(newDett);
    },
    createScheda() {
      let _ = this;
      _.method = "ADD";
      _.schedaData = {
        custId: window.systemData.custId,
        idScheda: null,
        nomeScheda: "",
        dettaglio: [],
        supportedLanguage: window.systemData.supportedLanguage
          .filter((lang) => {
            return lang.ifActive === 1;
          })
          .map((lang) => {
            return lang.language;
          }),
      };
    },
    getScheda() {
      let _ = this;
      _.method = "EDIT";
      if (_.selectedScheda) {
        _.chiamataAxios(
          "GET",
          "/auth/eventi/getSchedaValutazione/" + _.selectedScheda
        ).then((response) => {
          _.schedaData = response.data;
        });
      }
    },
    saveScheda(copia) {
      let _ = this;
      this.chiamataAxios(
        "POST",
        "/auth/eventi/saveScheda/" +
        (_.method !== "ADD" && !copia ? _.selectedScheda : ""),
        { dialogLoader: true, body: _.schedaData }
      ).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.loadData();
        }
      });
    },
    deleteScheda() {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/eventi/deleteScheda/" + _.selectedScheda,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.selectedScheda = null;
              _.loadData();
            }
          });
        }
      });
    },
  },
};
</script>